import { render, staticRenderFns } from "./prompt.vue?vue&type=template&id=099d3ded&scoped=true&"
import script from "./prompt.vue?vue&type=script&lang=js&"
export * from "./prompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../AppPlus/H5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099d3ded",
  null
  
)

export default component.exports